import { render, staticRenderFns } from "./NoAnswer.vue?vue&type=template&id=70140e88&"
import script from "./NoAnswer.vue?vue&type=script&lang=js&"
export * from "./NoAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports